// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./ineditGlass.jpg')
const allTwoEs = require('./animated-2.gif')
const allTwoCa = require('./animated-2-Ca.gif')
const allFourEs = require('./animated-2.gif')
const allFourCa = require('./animated-2-Ca.gif')
const catalogTwoEs = require('./animated-2.gif')
const catalogTwoCa = require('./animated-2-Ca.gif')
const catalogFourEs = require('./animated-2.gif')
const catalogFourCa = require('./animated-2-Ca.gif')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
